import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { CustomerSummary } from '@/api/auth';

interface AuthState {
  token: string | null;
  customer: CustomerSummary | null;
  setSession: (token: string, customer: CustomerSummary) => void;
  clear: () => void;
}

/**
 * Auth state lives in localStorage so a page reload keeps the session.
 * Magic-link tokens grant a 7-day server-side JWT — that's our session
 * length. If a 401 ever lands, the client interceptor calls clear()
 * and the router redirects to /login.
 */
export const useAuthStore = create<AuthState>()(
  persist(
    set => ({
      token: null,
      customer: null,
      setSession: (token, customer) => set({ token, customer }),
      clear: () => set({ token: null, customer: null })
    }),
    { name: 'nurev-console-auth' }
  )
);

export const isAuthenticated = (): boolean => !!useAuthStore.getState().token;
